import { render, staticRenderFns } from "./RoomEditor.vue?vue&type=template&id=55d7dba6&"
import script from "./RoomEditor.vue?vue&type=script&lang=ts&"
export * from "./RoomEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports